import Player from "@vimeo/player"

/**
 * Class VimeoEmbed
 * Renders a (playing) Vimeo video iframe over the trigger when clicked
 */
export default class VimeoEmbed {

    /**
     * VimeoEmbed constructor
     * @param $triggerElement
     */
    constructor($triggerElement) {
        if ($triggerElement === null || !$triggerElement instanceof Element) throw new Error('Missing required parameter `$triggerElement` in class VimeoEmbed or given parameter was not a valid Element.')

        this.state = {
            $triggerElement,
            $videoContainerElement: $triggerElement.querySelector('.vimeo-embed__iframe-container'),
            vimeoEmbedId: parseInt($triggerElement.dataset.vimeoEmbedId),
            active: false,
            loading: false
        }

        //bind events
        this.triggerClickEvent = $triggerElement.addEventListener('click', this.handleTriggerClick.bind(this))
    }

    /**
     * Handle trigger click
     * @param event
     */
    handleTriggerClick(event) {
        if (event) event.preventDefault()
        if (!this.state.active && !this.state.loading) this.renderVimeoEmbed()
    }

    /**
     * Render Vimeo embed html
     */
    renderVimeoEmbed() {
        this.setLoading(true)

        //load player
        const playerInstance = new Player(this.state.$videoContainerElement, {id: this.state.vimeoEmbedId})

        //when player is ready, stop loading and play the video
        playerInstance.ready().then(() => {
            setTimeout(() => {
                this.setLoading(false)
                playerInstance.play()
                this.setActive(true)
            }, 250)
        })
    }

    /**
     * Set loading state
     * @param {boolean} newState
     */
    setLoading(newState = false) {
        this.state.loading = newState
        this.state.$triggerElement.dataset.videoLoading = newState ? "true" : "false"
    }

    /**
     * Set active state
     * @param {boolean} newState
     */
    setActive(newState = false) {
        this.state.active = newState
        this.state.$triggerElement.dataset.videoActive = newState ? "true" : "false"
    }
}